const DashboardActionTypes = {
	DASHBOARD_START: 'dashboard_start',
	DASHBOARD_SUCCESS: 'dashboard_success',
	DASHBOARD_FAILURE: 'dashboard_failure',
	DASHBOARD_RESPONSE_CHANGED: 'dashboard_response_changed',
	DASHBOARD_RESPONSE_REST_START: 'dashboard_response_rest_start',
	GET_SECTION_LIST_FOR_DASHBOARD_START: 'get_section_list_for_dashboard_start',
	GET_SECTION_LIST_FOR_DASHBOARD_SUCCESS: 'get_section_list_for_dashboard_success',
	GET_SECTION_LIST_FOR_DASHBOARD_FAILURE: 'get_section_list_for_dashboard_failure',
	GET_SECTION_LIST_FOR_DASHBOARD_RESPONSE_CHANGED: 'get_section_list_for_dashboard_response_changed',
	GET_SECTION_LIST_FOR_DASHBOARD_RESPONSE_REST_START: 'get_section_list_for_dashboard_response_rest_start',
	GET_SECTION_LIST_FOR_DASHBOARD_RESPONSE_REST_SUCCESS: 'get_section_list_for_dashboard_response_rest_success',
	GET_PENDING_LEAVE_REQUESTS_START: 'get_pending_leave_requests_start',
	GET_PENDING_LEAVE_REQUESTS_SUCCESS: 'get_pending_leave_requests_success',
	GET_PENDING_LEAVE_REQUESTS_FAILURE: 'get_pending_leave_requests_failure',
	GET_PENDING_LEAVE_REQUESTS_RESPONSE_CHANGED: 'get_pending_leave_requests_response_changed',
	GET_PENDING_LEAVE_REQUESTS_RESPONSE_REST_START: 'get_pending_leave_requests_response_rest_start',
	// Enhanced Dashboard Actions
	DASHBOARD_ENHANCED_START: 'dashboard_enhanced_start',
	DASHBOARD_ENHANCED_SUCCESS: 'dashboard_enhanced_success',
	DASHBOARD_ENHANCED_FAILURE: 'dashboard_enhanced_failure',
	DASHBOARD_ENHANCED_RESPONSE_CHANGED: 'dashboard_enhanced_response_changed',
	DASHBOARD_ENHANCED_RESPONSE_REST_START: 'dashboard_enhanced_response_rest_start',
	// Enhanced Employee List Actions
	EMPLOYEE_LIST_ENHANCED_START: 'employee_list_enhanced_start',
	EMPLOYEE_LIST_ENHANCED_SUCCESS: 'employee_list_enhanced_success',
	EMPLOYEE_LIST_ENHANCED_FAILURE: 'employee_list_enhanced_failure',
	EMPLOYEE_LIST_ENHANCED_RESPONSE_CHANGED: 'employee_list_enhanced_response_changed',
	EMPLOYEE_LIST_ENHANCED_RESPONSE_REST_START: 'employee_list_enhanced_response_rest_start',
};



export default DashboardActionTypes;
